export default "__VITE_ASSET__D9CY6GMl__"